import React from 'react';

const DocumentIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
    <g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 9C8 7.34315 9.34315 6 11 6H21C22.6569 6 24 7.34315 24 9V23C24 24.6569 22.6569 26 21 26H11C9.34315 26 8 24.6569 8 23V9ZM20.5 16.5C20.5 16.2239 20.2761 16 20 16H11.5L11.4101 16.0081C11.1769 16.0504 11 16.2545 11 16.5C11 16.7761 11.2239 17 11.5 17H20L20.0899 16.9919C20.3231 16.9496 20.5 16.7455 20.5 16.5ZM16 19.5C16 19.2239 15.7761 19 15.5 19H11.5L11.4101 19.0081C11.1769 19.0504 11 19.2545 11 19.5C11 19.7761 11.2239 20 11.5 20H15.5L15.5899 19.9919C15.8231 19.9496 16 19.7455 16 19.5ZM12 10C11.4477 10 11 10.4477 11 11V13C11 13.5523 11.4477 14 12 14H14C14.5523 14 15 13.5523 15 13V11C15 10.4477 14.5523 10 14 10H12Z'
        fill='currentColor'
      />
    </g>
  </svg>
);

export default DocumentIcon;
